import React from 'react';
import { backEnvelopeStatusToFront, frontEnvelopeStatusToStyle, backSignerStatusToFront, frontSignerStatusToStyle, backSignerBatchStatusToFront, frontSignerBatchStatusToStyle, backEnvelopeFolderStatusToFront, frontEnvelopeFolderStatusToStyle, backEnvelopeFolderDecisionToFront, frontEnvelopeFolderDecisionToStyle, frontRuleAnalysisResultToStyle } from '../utils/utils';

function StatusIconText (props) {

  const { id, envelope_status, signer_status, signer_batch_status, envelope_folder_status, envelope_decision_status, rule_analysis_status, type } = props

  let frontStatus
  let statusStyle
  let value

  if (type==="signer_status") {
    if(rule_analysis_status === 'in_manual_analysis'){
      frontStatus = backSignerStatusToFront[rule_analysis_status]
      statusStyle = frontSignerStatusToStyle[frontStatus]
    } else if( rule_analysis_status === 'reproved') {
      frontStatus = backSignerStatusToFront[rule_analysis_status]
      statusStyle = frontSignerStatusToStyle[frontStatus]
    } else {
      frontStatus = backSignerStatusToFront[signer_status]
      statusStyle = frontSignerStatusToStyle[frontStatus]
    }
    value = signer_status
  }
  else if (type==="envelope_status") {
    if(rule_analysis_status === 'in_manual_analysis' && (envelope_status === 'waiting_for_rule_analysis' || envelope_status === 'in_manual_analysis')){
      frontStatus = backEnvelopeStatusToFront[rule_analysis_status]
      statusStyle = frontEnvelopeStatusToStyle[frontStatus]
    } else {
      frontStatus = backEnvelopeStatusToFront[envelope_status]
      statusStyle = frontEnvelopeStatusToStyle[frontStatus]
    }
    value = envelope_status

  }
  else if (type==="signer_batch_status") {
    frontStatus = backSignerBatchStatusToFront[signer_batch_status]
    statusStyle = frontSignerBatchStatusToStyle[frontStatus]
    value = signer_batch_status
  }
  else if (type==="envelope_folder_status") {
    frontStatus = backEnvelopeFolderStatusToFront[envelope_folder_status]
    statusStyle = frontEnvelopeFolderStatusToStyle[frontStatus]
    value = envelope_folder_status
  }
  else if (type==="envelope_folder_decision") {
    frontStatus = backEnvelopeFolderDecisionToFront[envelope_decision_status] || "pending"
    statusStyle = frontEnvelopeFolderDecisionToStyle[frontStatus]
    value = envelope_decision_status
  }
  else if (type==="rule_analysis_result") {
    if (rule_analysis_status === 'in_manual_analysis' && (envelope_status === 'waiting_for_rule_analysis' || envelope_status === 'in_manual_analysis')) {
      return null
    }
    statusStyle = frontRuleAnalysisResultToStyle[rule_analysis_status]
    if (!statusStyle) {
      return null
    }
    value = rule_analysis_status
  }

  if (!statusStyle) {
    statusStyle = { backgroundColor: "background-light-gray", icon: null, text: value }
  }

  return (
    <div id={id?id:null} style={{padding: '5px 5px'}} className={([statusStyle.backgroundColor]&&[statusStyle.backgroundColor])+" status-icon-text"}>
      {statusStyle.icon?statusStyle.icon:null}
      <p id={id?id:null}>
        {statusStyle.text?statusStyle.text:value}
      </p>
    </div>
  )
}

export default StatusIconText;
